module.exports = __webpack_public_path__ + "img/2023big19.3d22e792.png";